import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  CircularProgress,
} from "@mui/material";
import { useWebApiV1UpdateOrderMutation } from "@providers/hop-ord-server/api";
import { OrderStatus } from "@enums";
import { useState } from "react";

interface ApprovePlanModalProps {
  open: boolean;
  orderId: number;
  onClose: () => void;
  onApprove: () => void;
}

const ApprovePlanModal = ({
  open,
  orderId,
  onClose,
  onApprove,
}: ApprovePlanModalProps) => {
  const [updateOrder] = useWebApiV1UpdateOrderMutation();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleApprove = () => {
    setIsSubmitting(true);
    updateOrder({
      orderId: Number(orderId),
      orderIn: { status: OrderStatus.APPROVED },
    }).then(() => {
      onApprove();
      setIsSubmitting(false);
    });
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Approve plan</DialogTitle>
      <DialogContent>
        <Typography>
          By approving, you acknowledge no further changes will be made to the
          plan.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleApprove} variant="text" sx={{ width: "82px" }}>
          {isSubmitting ? <CircularProgress size={24} /> : "Approve"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ApprovePlanModal;
